import React from "react";
import { IconContext } from "react-icons";

interface IventoryCardProps {
  icon: React.ReactNode;
  iconSize: string;
  title: string;
  quantity?: number;
  className?: string;
  divClassName?: string;
  iconClassName?: string;
  alertLabel?: string;
  tooltip?: string; // Nova propriedade para o texto do tooltip
  legend?: string;
}

const IventoryCard: React.FC<IventoryCardProps> = ({ 
  icon, 
  iconSize, 
  title, 
  quantity, 
  className, 
  iconClassName, 
  alertLabel, 
  divClassName,
  tooltip,
  legend
}) => {
  return (
    <div className={`bg-gray/40 col-span-1  transition-all duration-300 transform hover:scale-[1.03] hover:shadow-2xl hover:-translate-y-1  rounded-md pt-8 gap-2 flex flex-col items-center justify-center relative group ${divClassName}`}>
      {/* Tooltip que aparece no hover */}
      {tooltip && (
        <span className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden w-48 px-2 py-1 text-xs text-white bg-black rounded group-hover:block z-50">
          {tooltip}
          {/* Pequena seta apontando para baixo */}
          <span className="absolute left-1/2 transform -translate-x-1/2 top-full border-4 border-transparent border-t-black"></span>
        </span>
      )}
      
      <IconContext.Provider value={{ size: iconSize, className: iconClassName }}>
        {icon}
      </IconContext.Provider>
      <h2 className={`font-semibold text-2xl text-center text-gray3 ${className}`}>{title}</h2>
      {quantity !== undefined && (
        <h2 className={`text-gray2 text-xl ${className}`}>Total de {title}: {quantity}</h2>
      )}
      {legend && (
        <p className="text-gray-500 text-sm text-center px-4">{legend}</p>
      )}
      <p className={`font-bold p-4 text-center ${className}`}>{alertLabel}</p>
    </div>
  );
};

export default IventoryCard;